import { render, staticRenderFns } from "./CredentialScopeArray.vue?vue&type=template&id=1764bbab"
import script from "./CredentialScopeArray.vue?vue&type=script&lang=js"
export * from "./CredentialScopeArray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports